import { useEffect, useState } from 'react';
import { Card, Table, Pagination } from 'react-bootstrap';
import PageHeader1 from '../../components/common/PageHeader1';
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function ExitLocationsList() {
    const [locations, setLocations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage] = useState(10);

    const fetchLocations = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/exit-locations?page=${currentPage}&per_page=${perPage}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setLocations(response.data.data);
            setTotalPages(Math.ceil(response.data.total / response.data.per_page));
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading locations');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this location?')) {
            return;
        }
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/exit-locations/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Location deleted successfully');
            fetchLocations();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error deleting location');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    useEffect(() => {
        fetchLocations();
    }, [currentPage]);

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Valet Location List' righttitle='Add Location' link='/accounts/exit-locations-add' routebutton={true} permission='exit-locations.create' />
                
                <Card className="mb-3">
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Logo</th>
                                    <th>Location Name</th>
                                    <th>Phone Number</th>
                                    <th>Parking Space</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {locations.map((location) => (
                                    <tr key={location.id}>
                                        <td>#{location.id}</td>
                                        <td>
                                            {location.logo ? (
                                                <img 
                                                    src={`${process.env.REACT_APP_STORAGE_URL}${location.logo}`} 
                                                    alt={location.name}
                                                    style={{ maxWidth: '100px', maxHeight: '50px' }}
                                                />
                                            ) : (
                                                <span className="text-muted">No logo</span>
                                            )}
                                        </td>
                                        <td>{location.name}</td>
                                        <td>{location.phone_number || '-'}</td>
                                        <td>{location.parking_space}</td>
                                        <td>
                                            <span className={`badge ${location.is_active ? 'bg-success' : 'bg-danger'}`}>
                                                {location.is_active ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <EditButton
                                                    to={`${process.env.PUBLIC_URL}/accounts/exit-locations-edit/${location.id}`}
                                                    permission="exit-locations.edit"
                                                />
                                                <DeleteButton
                                                    permission="exit-locations.delete"
                                                    onDelete={() => handleDelete(location.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-center mt-3">
                            <Pagination>
                                <Pagination.First 
                                    onClick={() => handlePageChange(1)} 
                                    disabled={currentPage === 1}
                                />
                                <Pagination.Prev 
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}
                                />
                                
                                {[...Array(totalPages)].map((_, idx) => (
                                    <Pagination.Item
                                        key={idx + 1}
                                        active={idx + 1 === currentPage}
                                        onClick={() => handlePageChange(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Pagination.Item>
                                ))}
                                
                                <Pagination.Next 
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === totalPages}
                                />
                                <Pagination.Last 
                                    onClick={() => handlePageChange(totalPages)} 
                                    disabled={currentPage === totalPages}
                                />
                            </Pagination>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default ExitLocationsList;